var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMp = function SvgMp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M248 0h496v496H248z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mp_svg__a)",
    transform: "translate(-256)scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillRule: "evenodd",
    d: "M0 0h992.1v496H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.9,
    d: "M553.4 392.4s17.5-18.5 34.3-15c5-19.4 24.1-21 24.1-21s-1.9-21.5 22.5-26.2c.7-14.6 15.5-26.8 15.5-26.8s-3-22.6 12.5-27.9c-9.5-18 3.2-31 3-31.4s-16-28.5-1.9-36.5c-15-12.6-10-27-10-27s-16.4-4.1-10.5-23.7c-13.4-2.3-16.1-24-16.1-24S606 137 603.6 119c-13.7 2.2-15.2-11.3-15.4-11.3-.1 0-27 7.3-32.4-13-10.4 5.3-15-4.3-15-4.3s-15 7.4-23.9-6.9c-17.8 11.1-27.7-.5-27.7-.5s-23.4 15.5-31.1 3.5c-13.8 14-26.1 8-26.1 8s-10.4 18.4-27.3 13.7c-3.8 17.2-23.2 17.5-23.2 17.5s2 15.2-21.2 19.2c-3 17.8-15.1 20.9-15.1 20.9s1.2 17.3-9.8 22.8c4 9.8-6.2 21.7-6.2 21.7S340 224 325.3 239c14.2 3.7 4 28.1 4 28.1s19.4 8.8 7.1 25c14 4.4 9.6 15.6 9.8 22.1 9 4 16.8 2 13 20 27.4 3 14.4 18.2 14.4 18.2s12.8.5 7.8 10.6c23.3-.5 26.7 17.5 26.7 17.5s21.7-5.7 24.6 2.7c2.8 8.4-9.5 65-9.5 65s-18.3 0-32-14.6c-31.9-.8-24.8-21.8-25.3-21.8s-10.6 3.8-15.8-13.7c-21.4 4.4-20.7-13.6-20.9-13.8-.2-.1-9.6-4.3-6-13.2-22 2-20.4-19.5-20.4-19.5-4.8-2-6.6-6.5-5.9-11-2.8-1-22.4-1.3-12.3-27-18.6-11.3-7-24.3-7-24.3s-25.8-13.3-6-28.6C257 239 273 228 273 228s-20.5-20.8.3-35.6c-3.4-31.7 15.5-39.2 15.5-39.2s-10-25.7 17-36.5c1.7-26 20.5-26.8 20.5-26.8s.5-20.7 30-18.6c5.8-18.5 26-14.8 26-14.8s6.2-22.4 33.6-11.6c14-27.3 34.7-13.3 34.7-13.3s13.1-8.6 19.7-6c8.3-14.2 26-.5 37.5 2.3 4.2-1.6 19-12.8 30.4 1.3 15.2-10 28.1 8 28.1 8s20.9-10.7 30.6 13.6c44.3-4 37.9 24.9 37.9 24.9s34.8-8 27.2 26.7c31.7 2.2 28.5 23 28.5 23s20 15.2 11.2 28.8c17.8.8 11.3 18 11.3 18s13.6 5.2 2.3 26.4c26.1 20.9 5 41.5 5 41.4-.3-.2 13.9 16.8 1.1 36.3 3.9 31-11.8 38.9-11.8 38.9s4 20-13.4 25.7c-.4 23.5-22.6 26.4-22.6 26.4s6 10.2-16.1 21c-.9 15.8-23.9 17-23.9 17s-2.2 29-31.5 21.2c-7 23.2-41.3 16.3-42 16s-6.6-49.8-6.6-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.9,
    d: "M340.9 114.8s7.4 6.4 6 16-6.9 22.9-5.8 32.8c.7 4 .4 11.1.4 11.1s-6.6-9.4-6.7-19.5 7.2-19.7 7.2-27.2-1.3-13.3-1.1-13.2zm-3.7 2.9s-9.6 9.2-10.8 18.1c-1 4.6-1.3 26-1.4 35.6l-1.7 18.6c-.3 4.2 7-7.2 7.5-16.4a281 281 0 0 1 .7-32.7c.9-4 .7-8.3 2-12.2z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffd200",
    fillRule: "evenodd",
    stroke: "#ef8a10"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.9,
    d: "M548.9 87.7s12.5-5.8 16-16.5-10.8-10.8-12.7-7.4 1.6 11.9.7 14.1c-.9 2.3-6 7.7-4 9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.6,
    d: "M438.3 91.6s8.1-11.1 6-22.2-14.7-4.2-14.7-.3 7.2 9.6 7.5 12-1.5 9.6 1.2 10.5zm-21.9 6.6s8.1-11.1 6-22.2-14.7-4.2-14.7-.3 7.2 9.6 7.5 12-1.5 9.6 1.2 10.5zm-24.3 7.5s8.1-11.1 6-22.2-14.7-4.2-14.7-.3 7.2 9.6 7.5 12-1.5 9.6 1.2 10.5zm-17 17s8-11 6-22.1c-2.2-11.1-14.8-4.2-14.8-.3s7.2 9.6 7.5 12-1.5 9.6 1.2 10.5zm-18 16.6s8-11.1 6-22.2c-2.2-11.1-14.8-4.2-14.8-.3s7.2 9.6 7.5 12-1.5 9.6 1.2 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.9,
    d: "M398.4 43.2s-10.8 8.5-11.7 19.7c-1 11.3 13 8 14 4.3s-4.3-11.2-4-13.6c.4-2.4 4-8.8 1.7-10.4zm36-11.1s-10.8 8.5-11.8 19.7c-1 11.3 13 8 14.1 4.3s-4.3-11.2-4-13.6c.4-2.4 4-8.8 1.7-10.4zm-134.1 97.1s2.2 13.6 11.6 19.8 13.3-7.5 10.5-10.3-11.9-1.5-13.8-3c-2-1.4-5.8-7.8-8.3-6.5zm-18 46s.1 13.8 8.4 21.4c8.3 7.7 14.3-5.3 12-8.5s-11.5-3.4-13.2-5.1c-1.7-1.8-4.5-8.6-7.2-7.8zm41.5 51.4s-5-12.8-15.4-17c-10.4-4.3-11.5 10-8.2 12 3.2 2.2 12-.7 14.1.3 2.2 1 7.2 6.5 9.5 4.7zm-8.7-22.2s8.4-11 6.5-22c-1.9-11.2-14.6-4.5-14.7-.6s7 9.7 7.3 12.1-1.7 9.6 1 10.5zM574.5 98.8s12.4-5.8 16-16.5-10.8-10.8-12.7-7.4 1.6 11.9.7 14.1c-.9 2.3-6 7.7-4 9.8zm37.7 18.8s7.3-11.6 4.5-22.6c-2.8-10.9-15-3.2-14.7.7s7.8 9.1 8.3 11.5-.9 9.7 1.9 10.4zm103 106.9s-5-12.8-15.4-17.1-11.5 10-8.3 12.2c3.3 2 12-.9 14.2.2 2.2 1 7.2 6.5 9.5 4.7zm-50.4 8s.3-13.8 8.7-21.3 14.2 5.5 11.9 8.6c-2.4 3.1-11.6 3.3-13.3 5s-4.6 8.6-7.3 7.7zm-8.1-145.7s-12.8-4.9-23 0-.2 15.4 3.6 14.3 7.3-9.4 9.6-10.4 9.6-1 9.8-3.9zm-29.4-24.6s-12.8-4.9-23 0-.2 15.4 3.6 14.3 7.4-9.4 9.6-10.4 9.7-1 9.8-3.9zm-43.8-23.5s-10.9 8.4-12 19.7 13 8.1 14 4.4c1.1-3.8-4.2-11.2-3.8-13.6s4.1-8.8 1.8-10.4zM554.9 32s-5 12.8-.1 23 15.3.2 14.3-3.5-9.5-7.4-10.4-9.7-1-9.6-3.8-9.8zm-81 49.3s8.9-10.4 7.6-21.7-14.4-5.2-14.7-1.3 6.5 10 6.7 12.5c0 2.4-2.2 9.4.4 10.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8a8c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.9,
    d: "M522.2 103.7s21.3 1.4 22.4 13.6-5.1 19.6-5.1 19.6 2.7 26.4-18.2 34.1c-22.3 2.7-57.3.6-57.3.6s-10.2 2.6-14.4-18.7-5.4-36.4-5.4-36.4 2.1-11.9 17.1-12.6c15-.8 60.8.1 61-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.9,
    d: "M539.4 136.8s-11.5 14.3-10.3 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8a8c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.9,
    d: "M524 170.3c2.8 2.4 5.5 5 6.1 13.8l1.2 17.6 14.9 134 13.1 96.9.9 15s-3.1 11-12 12c-6.3 13.3-41 17.2-44.4 17-3.1-.1-14.2-4.7-20.9-4.1s-18.3 5-23.5 4.3-17-4.8-19-13.3c-14.6-4.6-17-15.7-17-15.7l15.8-112.1 15.3-141.8s1.8-18.9 9.4-21.7c7.9-.7 48.7.8 60.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.9,
    d: "m443.6 364.3-3.1 99.1m99.5-86 8.7 81.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "m285.3 312.7-.4 1.2m412.2-4.7.3 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6b18b5",
    strokeLinejoin: "round",
    strokeWidth: 1.9,
    d: "M274.2 178.9s6.6 9 7.7 14.2 3.4 15.4 6.2 19.6c2.9 4.1 19 27.4 20 37.1 0 6.3-6.8 17.2-17 17.4-6.3-.2-22.7-4.4-23.4-18.4s5-14.4 5.7-23 .8-46.7.8-47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6b18b5",
    strokeLinejoin: "round",
    d: "M386.3 56s-6.8.4-12 3.2c-4 2.5-10.8 6-15.6 12.7-12.1 9.4-30.4 13.8-36.1 21.7-3.5 5.3-3.3 18.2 5.4 23.6 5.5 3.2 21.7 8.1 29.5-3.5 8-11.7 3.2-15 7-22.6 6.5-17.5 21.7-35 21.8-35.2zM550 38.8s-5-4.6-10.7-6.3c-4.6-1.2-12.2-.7-20.1-1.5-15.3-2.1-31-13.1-40.6-11.8-6.2 1.3-15.3 10.4-13.2 20.3 1.5 6.2 8.4 18.7 22.3 16.2 13.8-2.4 13.7-5.5 21.9-8 19.9-11.2 40.2-9 40.4-9zm162.4 157.8c1.2-2.6-1-7.4-2.4-13.2-1.5-4.5-3.6-11.5-8.9-17.7-6.3-14-5.2-33.3-11.4-40.7-4.4-4.7-17-7.6-24.3-.5-4.4 4.6-13 19.1-3.6 29.6s13.5 6.5 20 12c15.5 10.4 23 28.6 30.6 30.5zM707 319.4c2-3 5.9-8.5 5.4-13.2-.3-3.8 1.7-15 2-20 1.4-15.2 11-27.7 8.3-41-1.5-6.1-10.6-15-20.4-12.4-6.1 1.9-19.6 9.3-16.5 23 3.1 13.8 7.5 13.5 10.5 21.6 8.4 16.6 3 36.3 10.7 42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.9,
    d: "M594.3 416.8s-2.6 5 7.8 9.3m13-21.1s11.5-2.8 19.3 0m15.2-29.2c0 .2-1.6 5.2 7.6 12.4m-1-25.4s6.8 5 18.2 4.8m-86.7 9.8s.4 13.2-6.4 19.4m29.2-39.8s11.1 2.8 20.3-1.8m51.3-17.5s2.4 3.4 14.8 2.8m-63-10.6c.3.2 14.5 4.8 23.5.6m4.8-55s.6-.7 5 14.7m6-58s-.6 8.2-7.2 11.8m49.3-45.3s-9.6 7.8-7.8 11m-40-16.6s5 8.4-3.1 14.2m-21-50.1s8.6-.4 12.4 7m-28.6-31.4h6.6m27.6-30c0 .3 1.8 1.9-1.6 5.3m-59.7-4.4s4.6 7.2 3.8 16m22.7-40.4c2-.2 8.8-3.2 8.8-3.2m-38.3-25.4c-.2 0-2.6 9 1.8 12.2M586 91.7c0 9.6 7.6 7.2 2.4 16.4m-21-24.4a66 66 0 0 0-12 10.8m-18.7-15.8s5 5 3.8 11.8m-18.4-15.8s-2.6 7.6-6 9.6m-20.6-11.6c-.2.4-4.2 9-7 10.6m-29.3-10.4c.2 0 4 8-1 13.8m-7.4-55.1c.2.2.8 6.2-3 11.4m-33 2.2c0 .2 1.7 6.8-9 9M394.7 106c.2.4 10.2 2 10.2 2m-35.1 21.1 12.1-3.8m-31.5 18.8c.4 0 8.4 1.4 10.4.4m-16 7s2.6 1.4.4 14.8m-39.4-50 4.9 7.2m-21.2 29.8c0-.2 4.8 7.2 11.2 8.6m26.5 29c.2 0 7.8-1.7 9-2.5M323.8 218c.2 0-.2-5 6-8.4m-14.2 20.8c0 .2 5.8 7.4 9.8 8.4m-13.2 5.3c.6-.2 6.8-5.6 14-5.2m-16 23.8s.2 6.2 18.6 4.6M312 284.6c0-.2 5.4-12.4 16.4-17m-1.6 32.6s1.6-5.2 10.8-8.8m-.6 29.3s6.6-5.4 9-6.2m-.8 22.2s4 4.2 14-3M297 340c1.2-.2 15.7-3.6 20.7 4m-15 8s15.4-2 17.4-.4m37.6 3.6s-2 4.2 17-2.8m6.5 10.4c-3.4 5.7.8 10.3-3.6 13m-54-5c.5-.5 7-2.7 6-11.8m-.3 25.5c.8-.2 11.4-4.8 13.6-2.4M350 398s1.4-9.4 4.4-10.4m11.5 24.6s8.8-.2 12.6-3m4.4-28.8c.2.2 8.2 4.4 25.2.2m-18.8 38s2.4 12.1 2.2 15"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.84875 -.23108 .23809 1.90478 237.3 58.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.84875 -.23108 .23809 1.90478 235.6 38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.8213 -.39265 .40456 1.87649 218 57.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.66103 -.84397 .86954 1.71136 192.5 159.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.66103 -.84397 .86954 1.71136 184.5 141.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.5836 -.9816 1.01134 1.63158 174.3 164.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.48128 -1.1301 1.16435 1.52616 167.2 194.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.30182 -1.3329 1.37328 1.34126 169 247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(1.17368 -1.44698 1.49084 1.20925 167.8 274.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(.91718 -1.62175 1.6709 .94498 188 334.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(.76579 -1.6985 1.74996 .78897 193.6 360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(.65019 -1.74601 1.79893 .66988 194.9 377.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(.51503 -1.79055 1.84481 .53064 200.8 397.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(.23314 -1.8485 1.90451 .2402 237.1 442.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(.07476 -1.86165 1.91806 .07702 250.5 463.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(.07476 -1.86165 1.91806 .07702 230.4 464)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-.41519 -1.81629 1.87134 -.42776 326.6 516.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-.56358 -1.77586 1.82969 -.58066 344.7 530.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-.77108 -1.69608 1.74749 -.79446 383.3 545.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-.91296 -1.62412 1.67333 -.94064 405.7 556.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.08406 -1.5153 1.56121 -1.1169 440.5 564.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.20839 -1.41812 1.4611 -1.245 464.3 570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.30696 -1.32783 1.36808 -1.34656 483.3 576.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.41352 -1.21378 1.25056 -1.45636 509.2 580.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.5349 -1.05613 1.08813 -1.5814 545 576.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.69349 -.77677 .8003 -1.74482 606.3 551.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.75693 -.62003 .63882 -1.81018 632.4 544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.85518 -.13795 .1773 -1.53226 703.5 438.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 119c0-2-.8-4-2-5q-2.2-1.6-4.2 0c-2 1.6-2.1 3-2.1 5q.1 3.3 2 5.1 2.3 1.6 4.2 0c1.9-1.6 2.2-3 2.1-5z",
    transform: "matrix(-1.81654 -.41408 .42661 -1.8716 666.6 524.7)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe300",
    fillRule: "evenodd",
    d: "M680 196q3.4-4 7.6-2.5c-1-7-3.2-9.3-6-8.5-2.6.8-3.8 4.4-1.7 11zm3.7 21c2.7-2.5 5-3 7.8-2-.5-7-2.5-9.5-5.2-8.8s-4.2 4-2.6 10.7zm-9-40.3c1.8-3.2 3.8-4.5 6.9-4.3-2.8-6.4-5.5-8.2-7.9-6.7s-2.7 5.3 1 11m-9.3-19q2.4-4.8 6.8-4.4c-2.7-6.5-5.5-8.2-7.9-6.7-2.3 1.5-2.6 5.3 1.1 11zM643 122.5q1.7-5 6-5.4c-3.7-6-6.7-7.2-8.8-5.3s-1.8 5.6 2.8 10.7m-14.7-15.3q1.4-5 5.9-5.5c-4-5.8-7-7-9-5-2.1 1.9-1.7 5.6 3.1 10.5m-30.8-26q-.2-5.3 3.8-7c-5.5-4.4-8.8-4.5-10.1-2-1.4 2.4.3 5.8 6.3 9m16 12c.6-3.6 2-5.5 5-6.3-4.7-5.2-7.9-5.9-9.6-3.7-1.8 2.2-.8 5.8 4.7 10zm-34.3-22.1q-.7-5.2 3-7.4c-6-3.7-9.1-3.6-10.2-1s.9 5.9 7.2 8.4M560.5 63c-1-3.5-.4-5.8 2-7.8-6.5-2.8-9.6-2.1-10.3.6s1.7 5.6 8.3 7.2m-20.1-6.2c-1.3-3.4-.9-5.8 1.3-8-6.7-2.2-9.8-1.3-10.3 1.5s2.2 5.5 9 6.5M520.6 53q-2.3-4.7.7-8c-6.8-1.8-9.8-.7-10.1 2.1s2.5 5.3 9.4 5.8zm-21-1.6q-2.8-4.6 0-8c-7-1.1-10 .3-10 3.1.1 2.8 3.2 5 10 4.9m-41 3c-2.5-2.6-3.2-4.9-2-7.7-7 .6-9.5 2.7-8.8 5.4s4.2 4.2 10.8 2.3m20.2-2.6c-2.2-3-2.5-5.3-1-8-7-.3-9.8 1.4-9.4 4.2.3 2.8 3.6 4.7 10.4 3.8m-40 7c-3-2.3-3.9-4.5-3.2-7.5-6.8 1.7-9 4.1-7.9 6.7s4.8 3.5 11 .7zm-38 17.4q-4.7-2.4-4.5-6.7c-6.4 3-8 5.7-6.5 8 1.6 2.4 5.4 2.6 11-1.3m18.3-9.4q-4.4-2.8-3.6-7.1c-6.7 2.1-8.7 4.7-7.4 7.2s5 3.1 11 0zm-52.3 33q-5.1-1.1-5.8-5.5c-5.6 4.2-6.7 7.3-4.7 9.2 2 2 5.8 1.3 10.5-3.6zM383 86.7q-5-1.6-5.3-6c-6 3.7-7.2 6.7-5.4 8.8 1.9 2.1 5.6 1.8 10.7-2.8M352.3 114q-5.1-.8-6.2-5c-5.3 4.6-6 7.8-3.8 9.5 2.1 1.8 5.8.9 10-4.5m-12.9 16.8q-5.2-.3-6.7-4.5c-4.8 5.2-5.2 8.4-2.9 10s5.9.2 9.6-5.5M328.6 148q-5.2.6-7.3-3.4c-4 5.9-4 9.1-1.4 10.3s5.9-.6 8.7-6.9m-9.5 18.4c-3.6.7-5.9 0-7.7-2.4-3.1 6.2-2.7 9.4 0 10.3 2.7.8 5.7-1.4 7.7-8zm-7.6 18.8q-4.9 2-8-1.2c-2 6.7-1.1 9.8 1.6 10.2s5.5-2.3 6.4-9m-5.1 21q-4.7 2.2-8-.7c-1.7 6.8-.5 9.8 2.3 10 2.8.3 5.3-2.6 5.7-9.4zm-2 17.4q-4.6 2.4-8 .6c-1 5.5.5 7.7 3.3 7.5s5-2.7 4.6-8.1zm352.7-83q1.7-5 6-5.3c-3.6-6-6.6-7.3-8.7-5.5-2.1 1.9-1.8 5.6 2.7 10.8m28.9 97.6c2.7-2.4 5-3 7.8-1.8-.5-7-2.5-9.6-5.2-9-2.8.7-4.2 4.2-2.6 10.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.9,
    d: "M658.5 124c-.1 0-8 7.8-6.6 17.4 1.3 9.6 7.4 21.4 6.3 31.3s-3 16.5-3 16.5 9.3-10.5 9.4-20.6c.1-10-6.3-23.4-6.3-30.8s.3-14 .2-13.9zm14.5 32s-6.2 4.6-5.6 15 11.4 29.6 11.4 29.6 7.9 16.2 7.6 20.4c-.2 4.2 1.5-4 .7-13.3-.8-9.2-12.7-29.6-12.7-29.6s-2.5-4.2-2.3-11.1c.3-7 1-10.9.9-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b18b5",
    fillRule: "evenodd",
    d: "M488 26.8c0-2.2-2.5-4-5.5-4s-5.4 1.8-5.4 4c0 2.1 2.4 3.9 5.4 3.9s5.4-1.8 5.4-4zm2.3 9c0-2-2.6-3.7-5.6-3.7-3.1 0-5.6 1.7-5.6 3.8s2.5 3.7 5.6 3.7 5.6-1.7 5.6-3.8m6.9-10.7s-6.4 4.8-3.8 6.7 10-4.2 10-4.2zm187.7 109.6a4 4 0 0 0-1.7-3.3 3 3 0 0 0-3.4 0 4 4 0 0 0-1.6 3.3 4 4 0 0 0 1.7 3.3 3 3 0 0 0 3.3 0 4 4 0 0 0 1.7-3.3m-2.5-9.1c0-2.3-1.5-4.1-3.5-4.1s-3.5 1.8-3.5 4.1 1.6 4.1 3.5 4.1 3.5-1.8 3.5-4.1m1.7 18.6c0-1.2-.6-2.2-1.4-2.2s-1.3 1-1.3 2.2.6 2.1 1.3 2.1 1.4-1 1.4-2.1m5.6-16.6c0-1.4-.6-2.5-1.3-2.5s-1.4 1.1-1.4 2.5.6 2.4 1.4 2.4q1.2-.2 1.3-2.4m-15.3 1.6c0-1-.6-2-1.4-2s-1.4 1-1.4 2 .6 2 1.4 2q1.3-.2 1.4-2m2.4 13.2c0-1.8-1.3-3.3-2.9-3.3s-2.9 1.5-2.9 3.3 1.3 3.1 3 3.1 2.8-1.4 2.8-3.2zm-7.6-5.8c0-1.5-1.1-2.8-2.5-2.8s-2.4 1.2-2.4 2.8 1.1 2.7 2.4 2.7c1.4 0 2.5-1.2 2.5-2.7m-1.2-7.8q0-1.3-1-2a2 2 0 0 0-2.2 0 2 2 0 0 0-1 2q0 1.3 1 2a2 2 0 0 0 2.1 0 2 2 0 0 0 1-2zm34.7 39.5c-3.2-4.2-8.2-6-11.3-4-3 2-3 7 .2 11.2 3.1 4.2 8.2 5.9 11.2 3.9 3.1-2 3-7-.1-11.1m9 76.6c.5-5.1-2-9.6-5.6-10-3.7-.5-7.2 3.3-7.8 8.4-.6 5 1.9 9.6 5.6 10s7.1-3.3 7.7-8.4zm1.8 44.5c1-5-1-9.6-4.6-10.4-3.7-.8-7.4 2.7-8.5 7.7s1 9.7 4.7 10.5c3.6.7 7.4-2.7 8.4-7.7zm8.6-41.7c0-2-1.4-3.6-3-3.6s-3 1.6-3 3.6 1.3 3.7 3 3.7 3-1.7 3-3.7m-7.5 8.4-6.2 7s-5.9.2-5.6 2.1 8.1 7.7 8 10 5.2-.6 5.2-.6l4.2-12.8s-.2-8.8-2.5-8.7-2.9 2.8-3 3zM304 253.3a3 3 0 1 0-6 0 3 3 0 0 0 6 0m2.8-9c0-1.8-1.4-3.2-3-3.2s-3 1.4-3 3.1 1.4 3.2 3 3.2 3-1.4 3-3.2zM282.4 201c-1.1-2.5-3.5-3.9-5.2-3-1.8.7-2.3 3.4-1.2 5.9 1.2 2.5 3.5 3.9 5.2 3 1.8-.7 2.3-3.4 1.2-5.9m7.3 27c-1.5-3.3-4.7-5.1-7-4s-3.2 4.4-1.7 7.6 4.8 5 7.2 4 3-4.4 1.5-7.7zm8 19.7c.4-4-1.2-7.8-3.8-8.3s-5 2.3-5.5 6.3 1.1 7.8 3.7 8.3c2.5.5 5-2.3 5.5-6.3zm-12.7 2.8c1.5-3.7 1-7.7-1.4-9s-5.4.9-7 4.6-1 7.8 1.3 9 5.5-.8 7-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b18b5",
    fillRule: "evenodd",
    d: "M279.2 242c0-1.9-1.5-3.4-3.3-3.4s-3.3 1.6-3.3 3.5 1.5 3.4 3.3 3.4 3.3-1.5 3.3-3.4zm-2.6-8.5a3 3 0 0 0-3-3.2c-1.7 0-3 1.4-3 3.2s1.3 3.1 3 3.1 3-1.4 3-3.1m2.8-16.5c0-3-1.3-5.3-3-5.3-1.5 0-2.8 2.4-2.8 5.3s1.3 5.3 2.9 5.3 2.9-2.4 2.9-5.3m8.9-1.3c.3-2.9-.6-5.4-2.2-5.6s-3.2 2-3.6 4.8c-.4 3 .6 5.4 2.2 5.7s3.2-2 3.6-4.9m63.3-126.4c1.2-4 0-8.2-2.7-9.2s-5.8 1.6-7 5.7 0 8.2 2.7 9.2 5.8-1.6 7-5.7m-12 18.3c3.5-3 5-7.2 3.3-9.3-1.6-2.1-5.8-1.4-9.4 1.6s-5 7.1-3.3 9.3c1.6 2 5.8 1.4 9.4-1.6m-7-10.2c3.4-2.5 5-6.1 3.3-8s-5.8-1.1-9.3 1.4c-3.5 2.6-5 6.2-3.4 8s5.9 1.2 9.4-1.4m27-17.8c2.4-1.7 3.4-4.2 2.3-5.5s-4-.8-6.3 1-3.4 4.2-2.3 5.5 4 .9 6.3-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b18b5",
    fillRule: "evenodd",
    d: "M345.5 96.9c1.6-2.5 1.7-5.2.2-6-1.4-.8-4 .5-5.5 3s-1.8 5.2-.3 6 4-.5 5.6-3m20.4-10.7c2.5-2.1 3.5-5 2.2-6.3-1.4-1.3-4.5-.7-7 1.4s-3.5 5-2.2 6.4c1.3 1.3 4.4.7 7-1.5M329 111.1c2.3-.1 4.1-1.3 4-2.6-.2-1.4-2.3-2.4-4.6-2.2-2.4 0-4.2 1.3-4 2.6s2.2 2.3 4.6 2.2m44.5-38c1.6-2.6 1.7-5.2.2-6-1.4-.9-4 .5-5.5 3s-1.7 5.1-.3 6c1.5.8 4-.6 5.6-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    fillRule: "evenodd",
    stroke: "#ef8a10",
    d: "M641.8 148.5s7.3-11.6 4.5-22.6c-2.8-10.9-15-3.2-14.7.7s7.8 9.1 8.3 11.5-.8 9.7 1.9 10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M501.7 51.9s26.4 1 26.6 18.1c-.1 2.7 0 5.8-1 13.5a18 18 0 0 0 8-15.8c.2-17.4-23.5-29.2-33.6-15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M484.9 51.1s21.3-4.4 21.5 12.7c.2 17-6.8 19.8-6.8 19.8S516 80.1 516 62.8c.1-17.4-21-25.1-31.1-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7df73",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M557.3 420.3S657 392.2 687 269.8c-17.5 125.6-126.6 165.4-126.6 165.4l-3.2-14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M567.5 428c3.1 0 10.7-8.5 15.1-9.4s4.9-5.4-.2-5.6c-5-.1-9.4 5.7-9.4 5.7s-4.3 3.8-8.9 4.2c-4.5.5-1.6 6.2 3.4 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    stroke: "#8c1800",
    strokeWidth: 2.6,
    d: "M625 385.1s-10.4 6-9 7.5c1.5 1.4 10.7-5.7 10.9-5.9.2-.1 3.9-4.7-2-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M588.8 412.4s-3.1-1.1 4.8-4.2 7.5-6.7 10-8.1c2.7-1.5 8.2-5.4 9.3-3.1s-5.8 6.8-7.4 7.3-9.6 7.8-11.9 8.4c-2.2.7-3.9.3-4.8-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 3.1,
    d: "M640.4 369.9c-6.8 7.6-6.8 7.4-6.8 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 2.9,
    d: "m650.6 357.4-6.5 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "m660.8 341.2-7.3 11.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 2.4,
    d: "m669.4 324.6-6 12m9.9-20.8-2 4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "m677.7 304.3-1.6 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7df73",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: "1pt",
    d: "M160.3 216s52-14.7 67.6-78.5c-9.1 65.5-66 86.2-66 86.2z",
    transform: "matrix(-1.9021 0 0 1.9542 731.4 -4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M416.4 425.5c-3 0-10.6-8.6-15-9.6-4.3-1-4.7-5.5.2-5.6 5-.2 9.4 5.8 9.4 5.8s4.3 3.8 8.8 4.3 1.6 6.2-3.4 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    stroke: "#8c1800",
    strokeWidth: "1pt",
    d: "M195.5 197.6s-5.4 3.2-4.6 4c.7.7 5.5-3 5.6-3.1s2-2.5-1-.9z",
    transform: "matrix(-1.9021 0 0 1.9542 731.4 -4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M395.4 409.6s3-1.1-4.9-4.3c-7.8-3.1-7.4-6.7-10-8.2s-8-5.5-9-3.2 5.7 7 7.3 7.5 9.5 7.9 11.7 8.6q3.4.8 4.9-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "m203.5 189.7-3.5 3.9",
    transform: "matrix(-1.9021 0 0 1.9542 731.4 -4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m208.9 183.2-3.4 4.1",
    transform: "matrix(-1.9021 0 0 1.9542 731.4 -4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "m214.2 174.7-3.8 6.1",
    transform: "matrix(-1.9021 0 0 1.9542 731.4 -4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "m218.7 166.1-3.2 6.3m5.2-10.9-1 2.2",
    transform: "matrix(-1.9021 0 0 1.9542 731.4 -4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "m223 155.5-.9 2.7",
    transform: "matrix(-1.9021 0 0 1.9542 731.4 -4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M691.9 247.2c.5 7.7 8 15 5 28.5-3.7 15.1-17 51.3-14.6 57.6-4-5.4-3.3-10.4-3.6-18s10.9-35.4 11.9-44.9c0-8.5.8-20 1.3-23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M691.9 247.4s12.2 15.5 11.6 27.8c-.7 12.2-7.5 26.6-5.2 33-4-5.4-5-8.9-5.3-16.4s6-15.8 4.8-24-6-20.4-6-20.4zm-401.4 3.4c-.5 7.7-6.2 14.6-3.3 28 3.8 15.1 17.2 34.4 15 56.5a33 33 0 0 0 5.5-19c.3-7.5-14.9-32.8-15.9-42.3 0-8.5-.8-20-1.3-23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M290.5 251s-12 15-11.3 27.3c.2 8.1 15.2 42.3 13 48.7 3.9-5.4 5-4.8 4.8-13-4.4-20.9-12.2-34.3-10.9-42.4s4.6-20.6 4.4-20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeDashoffset: 1,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m100 125.8 22 68.2h72l-58 42.2 22.1 68.2-58-42.1-58 42.1 22-68.2L6 194h71.8z",
    transform: "matrix(1.3389 0 0 1.3391 360.4 -54.9)"
  }))));
};
export default SvgMp;